import { Configuration, FormConfiguration } from "@app/models/configuration";
import { Institution } from "@app/models/institution";
import { Barrier } from "@app/models/barrier";
import { User } from "@app/models/user";
import { ChipColor } from "design-angular-kit";

export class Folder {
    uid!: number;
    ente!: Institution;
    sbarramento!: Barrier;
    aggiornamento!: string;
    creazione!: string;
    stato!: number;
    precedenteVersione!: number;
    numeroVersione!: number;
    versioneCorrente!: boolean;
    completamento!: Declaration[];
    operatoreFascicolo?: User;
    tipologia!: string;
    categoria!: string;
    titolare!: string;
    destinazioniUso!: number[];

    constructor(init?: Partial<Folder>) {
        if (init?.sbarramento) init.sbarramento = new Barrier(init.sbarramento);
        Object.assign(this, init);
    }

    checked?: boolean;

    get isDraft(): boolean {
        return this.stato === States.DRAFT;
    }

    get isAssigned(): boolean {
        return this.stato !== States.ASSIGNMENT;
    }

    get isCompleted(): boolean {
        return this.stato === States.COMPLETED;
    }

    get isClosed(): boolean {
        return this.stato === States.CLOSED;
    }

    get stateColor(): ChipColor {
        return StatesColor[States[this.stato] as keyof typeof StatesColor];
    }

    get frames(): Configuration[] {
        return this.completamento.map((item) => item.configurazione).sort((a, b) => a.nome.localeCompare(b.name));
    }
}

export class FolderList {
    risultati: Folder[] = [];

    constructor(items?: Folder[]) {
        if (items) this.risultati = items;
    }

    get checkedFolders(): Folder[] {
        return this.risultati.filter((items) => items.checked);
    }

    get allFoldersChecked(): boolean {
        return this.risultati.length === this.checkedFolders.length;
    }

    set allFoldersChecked(checked: boolean) {
        this.risultati.forEach((item) => (item.checked = checked));
    }
}

export class State {
    uid!: number;
    nome!: string;
}

export enum States {
    ASSIGNMENT = 1,
    DRAFT = 2,
    COMPLETED = 3,
    CLOSED = 4,
}

export enum StatesColor {
    ASSIGNMENT = "secondary",
    DRAFT = "warning",
    COMPLETED = "success",
    CLOSED = "primary",
}

export class Declaration {
    uid?: number;
    valido!: boolean;
    configurazione!: Configuration;
    dati!: FormConfiguration;
}
